var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M38.345,423.724h435.31c21.177,0,38.345-17.167,38.345-38.345v-49.931H0v49.931 C0,406.557,17.167,423.724,38.345,423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M512,126.621c0-21.177-17.167-38.345-38.345-38.345H38.345C17.167,88.276,0,105.443,0,126.621 v208.828h512V126.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M38.345,423.724h32.276V88.276H38.345C17.167,88.276,0,105.443,0,126.621V385.38 C0,406.557,17.167,423.724,38.345,423.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.681,
    y: 319.72,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 8.749
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.839,
    y: 145.48,
    style: {
      fill: "#FF4B55"
    },
    width: 3.122,
    height: 8.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M8.833,171.797h1.568v4.438h1.554v4.376h4.66v-4.376h1.569v-4.438h1.523v-5.834h-1.523v-4.438 h-1.569v-4.311h-4.66v4.311h-1.554v4.438H8.833V171.797z M11.955,167.422h1.539v-2.916h1.6v2.916h1.521v2.916h-1.521v2.98h-1.6 v-2.98h-1.539V167.422z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.839,
    y: 183.53,
    style: {
      fill: "#FF4B55"
    },
    width: 3.122,
    height: 8.812
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.751,
    y: 145.48,
    style: {
      fill: "#FF4B55"
    },
    width: 3.123,
    height: 8.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M29.09,157.214v4.311h-1.554v4.438h-1.569v5.834h1.569v4.438h1.554v4.376h4.66v-4.376h3.123v4.376 h4.676v-4.376h1.585v-4.438h1.523v-5.834h-1.523v-4.438h-1.585v-4.311h-4.676v4.311H33.75v-4.311H29.09z M36.874,167.422h1.569 v-2.916h1.569v2.916h1.537v2.916h-1.537v2.98h-1.569v-2.98h-1.569V167.422z M33.751,170.339h-1.537v2.98h-1.586v-2.98h-1.537 v-2.916h1.537v-2.916h1.586v2.916h1.537V170.339z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.839,
    y: 286.06,
    style: {
      fill: "#FF4B55"
    },
    width: 3.122,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.839,
    y: 220.17,
    style: {
      fill: "#FF4B55"
    },
    width: 3.122,
    height: 5.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.751,
    y: 183.53,
    style: {
      fill: "#FF4B55"
    },
    width: 3.123,
    height: 8.812
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.839,
    y: 319.72,
    style: {
      fill: "#FF4B55"
    },
    width: 3.122,
    height: 8.749
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "11.955,256.063 11.955,256 11.955,251.626 8.833,251.626 8.833,256 8.833,256.063  8.833,260.438 11.955,260.438  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.839,
    y: 400.31,
    style: {
      fill: "#FF4B55"
    },
    width: 3.122,
    height: 8.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.681,
    y: 400.31,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 8.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.839,
    y: 357.83,
    style: {
      fill: "#FF4B55"
    },
    width: 3.122,
    height: 8.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.751,
    y: 400.31,
    style: {
      fill: "#FF4B55"
    },
    width: 3.123,
    height: 8.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M53.961,157.151v4.374h-1.537v4.438h-1.569v5.834h1.569v4.374h1.537v4.376h4.693v-4.376h1.554 v-4.374h1.537v-5.834h-1.537v-4.438h-1.554v-4.374H53.961z M58.654,170.339h-1.569v2.915h-1.57v-2.915h-1.554v-2.98h1.554v-2.854 h1.569v2.854h1.569L58.654,170.339L58.654,170.339z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.681,
    y: 103,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 8.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.839,
    y: 103,
    style: {
      fill: "#FF4B55"
    },
    width: 3.122,
    height: 8.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.681,
    y: 183.53,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 8.812
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.681,
    y: 145.48,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 8.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.751,
    y: 103,
    style: {
      fill: "#FF4B55"
    },
    width: 3.123,
    height: 8.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.308,
    y: 378.32,
    style: {
      fill: "#FF4B55"
    },
    width: 3.091,
    height: 7.292
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "29.09,256.063 29.09,256 29.09,251.626 25.967,251.626 25.967,256 25.967,256.063  25.967,260.438 29.09,260.438  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M46.241,97.103v7.357h-3.107v7.292h-3.122v7.354h-3.139v7.292H33.75v-7.292h-3.123v-7.354h-3.091 v-7.292H24.43v-7.357h-3.123v7.357h-3.123v7.292h-3.091v7.354h-3.139v7.292H8.833v7.357h3.122v7.292h3.139v7.354h3.091v7.354h3.123 v7.292h3.091v-7.292h3.139v-7.354h3.091v-7.354h3.123v-7.292h3.123v7.292h3.139v7.354h3.091v7.354h3.138v7.292h3.108v-7.292h3.106 v-7.354h3.122v-7.354h3.106v-7.292h3.108v-7.357h-3.092v-7.292h-3.123v-7.354h-3.122v-7.292H49.35v-7.357H46.241z M30.627,133.753 h-3.091v7.292h-3.139v7.354h-3.09v-7.354h-3.123v-7.292h-3.091v-7.357h3.091v-7.292h3.123v-7.354h3.091v7.354h3.139v7.292h3.091 L30.627,133.753L30.627,133.753L30.627,133.753z M52.457,119.106v7.292h3.122v7.357h-3.122v7.292h-3.106v7.354h-3.108v-7.354 h-3.107v-7.292h-3.122v-7.357h3.122v-7.292h3.107v-7.354h3.108v7.354H52.457z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.751,
    y: 240.65,
    style: {
      fill: "#FF4B55"
    },
    width: 3.123,
    height: 7.292
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.751,
    y: 264.11,
    style: {
      fill: "#FF4B55"
    },
    width: 3.123,
    height: 7.292
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "41.55,256 41.55,256.063 41.55,260.438 44.657,260.438 44.657,256.063 44.657,256  44.657,251.626 41.55,251.626  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M43.135,400.312v7.292h3.107v7.293h3.108v-7.293h3.106v-7.292h3.122v-7.354h3.123v-7.354h3.092 v-7.292h-3.108v-7.357h-3.106v-7.292h-3.122v-7.354h-3.106v-7.292h-3.108v7.292h-3.138v7.354h-3.091v7.292h-3.139v7.357h-3.123 v-7.357h-3.123v-7.292h-3.091v-7.354h-3.139v-7.292h-3.091v7.292h-3.123v7.354h-3.091v7.292h-3.139v7.357H8.833v7.292h3.122v7.354 h3.139v7.354h3.091v7.292h3.123v7.293h3.123v-7.293h3.107v-7.292h3.091v-7.354h3.123v-7.354h3.123v7.354h3.139v7.354H43.135z  M30.627,385.603h-3.091v7.354h-3.139v7.354h-3.09v-7.354h-3.123v-7.354h-3.091v-7.292h3.091v-7.357h3.123v-7.292h3.091v7.292 h3.139v7.357h3.091L30.627,385.603L30.627,385.603z M40.013,378.312h3.122v-7.357h3.107v-7.292h3.108v7.292h3.106v7.357h3.122 v7.292h-3.122v7.354H49.35v7.354h-3.108v-7.354h-3.107v-7.354h-3.122C40.013,385.603,40.013,378.312,40.013,378.312z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "38.443,249.407 36.874,249.407 36.874,251.626 33.751,251.626 33.751,249.407  32.214,249.407 32.214,246.489 29.09,246.489 29.09,250.865 30.627,250.865 30.627,253.084 32.214,253.084 32.214,256  32.214,256.063 32.214,258.916 30.627,258.916 30.627,261.135 29.09,261.135 29.09,265.511 32.214,265.511 32.214,262.595  33.751,262.595 33.751,260.438 36.874,260.438 36.874,262.595 38.443,262.595 38.443,265.511 41.55,265.511 41.55,261.135  40.013,261.135 40.013,258.916 38.443,258.916 38.443,256.063 38.443,256 38.443,253.084 40.013,253.084 40.013,250.865  41.55,250.865 41.55,246.489 38.443,246.489  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.24,
    y: 126.4,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 7.357
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.24,
    y: 378.32,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 7.292
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M16.615,354.85v-4.374h1.569v-4.374h1.523v-5.897h-1.523v-4.374h-1.569v-4.376h-4.66v4.376h-1.554 v4.374H8.833v5.897h1.568v4.374h1.554v4.374H16.615z M11.955,341.661h1.569v-2.915h1.569v2.915h1.521v2.98h-1.521v2.916h-1.569 v-2.916h-1.569V341.661z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.308,
    y: 126.4,
    style: {
      fill: "#FF4B55"
    },
    width: 3.091,
    height: 7.357
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.681,
    y: 357.83,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 8.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M41.55,354.85v-4.374h1.585v-4.374h1.523v-5.897h-1.523v-4.374H41.55v-4.376h-4.676v4.376h-3.123 v-4.376h-4.66v4.376h-1.554v4.374h-1.569v5.897h1.569v4.374h1.554v4.374h4.66v-4.374h3.123v4.374H41.55z M33.751,344.641h-1.537 v2.916h-1.586v-2.916h-1.537v-2.98h1.537v-2.915h1.586v2.915h1.537V344.641z M36.874,341.661h1.569v-2.915h1.569v2.915h1.537v2.98 h-1.537v2.916h-1.569v-2.916h-1.569V341.661z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.751,
    y: 357.83,
    style: {
      fill: "#FF4B55"
    },
    width: 3.123,
    height: 8.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.751,
    y: 319.72,
    style: {
      fill: "#FF4B55"
    },
    width: 3.123,
    height: 8.749
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.681,
    y: 286.06,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 5.832
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M58.654,354.85v-4.374h1.554v-4.374h1.537v-5.834h-1.537v-4.438h-1.554v-4.313h-4.693v4.313h-1.537 v4.438h-1.569v5.834h1.569v4.374h1.537v4.374H58.654z M53.961,341.726h1.554v-2.916h1.569v2.916h1.569v2.915h-1.569v2.98h-1.569 v-2.98h-1.554V341.726z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "58.685,256 58.685,256.063 58.685,260.438 61.793,260.438 61.793,256.063 61.793,256  61.793,251.626 58.685,251.626  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.681,
    y: 220.17,
    style: {
      fill: "#FF4B55"
    },
    width: 3.108,
    height: 5.832
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M61.793,204.008h-3.108v-7.292h-3.106v-7.357h-3.122v-7.292h-3.106v-7.354h-3.108v7.354h-3.138 v7.292h-3.091v7.357h-3.139v5.832v1.459h-3.123v-7.292h-3.123v-7.357h-3.091v-7.292h-3.139v-7.354h-3.091v7.354h-3.123v7.292 h-3.123v7.357h-3.107v5.832v1.459H8.833v7.354h3.122v7.354h3.107v7.292h3.123v7.293h3.123v-7.293h3.091v-7.292h3.139v-7.354h-3.139 v-8.814h3.139v1.459v4.438h3.091v11.731h1.586v7.228l-4.676,0.063v5.834H24.4v4.374h-3.091v7.354h-3.123v-7.354h-3.123v-4.374 h-3.107v-4.376H8.833v13.188h3.122v5.897h3.107v5.073h3.123V256v0.063v2.854h-3.123v5.199h-3.107v5.834H8.833v13.188h3.122v-4.439 h3.107v-4.374h3.123v-7.292h3.123v7.292h3.091v4.374h3.139v5.897l4.676,0.063v7.228h-1.586v11.731h-3.091v4.374v1.523h-3.139 v-8.877h3.139v-7.292h-3.139v-7.292h-3.091v-7.357h-3.123v7.357h-3.123v7.292h-3.107v7.292H8.833v7.354h3.122v1.523v5.769h3.139 v7.357h3.091v7.354h3.123v7.292h3.091v-7.292h3.139v-7.354h3.091v-7.357h3.123v-7.292h3.123v1.523v5.769h3.139v7.357h3.122v7.354 h3.107v7.292h3.108v-7.292h3.106v-7.354h3.122v-7.357h3.106v-7.292h3.108v-7.354h-3.108v-7.292h-3.106v-7.292h-3.122v-7.357h-3.106 v7.357h-3.108v7.292h-3.138v7.292h3.138v7.354v1.523h-3.138v-1.523v-4.374h-3.091v-11.731h-0.445h-1.124v-7.292h1.124h0.841h1.141 h1.585v-5.897h3.107v-4.374h3.108v-7.292h3.106v7.292h3.122v4.374h3.123v4.439h3.092v-13.188h-3.092v-5.834h-3.123v-5.199h-3.122 v-2.854V256v-2.916h3.122v-5.073h3.123v-5.897h3.092v-13.188h-3.092v4.376h-3.123v4.374h-3.122v7.354h-3.106v-7.354h-3.108v-4.374 h-3.107v-5.834H41.55h-1.141h-0.841h-1.124v-7.292h1.124h0.445v-11.731h3.091v-4.438v-1.459h3.138v1.459v7.354h-3.138v7.354h3.138 v7.292h3.108v7.293h3.106v-7.293h3.122v-7.292h3.106v-7.354h3.108L61.793,204.008L61.793,204.008z M43.135,242.113v2.916v2.98 h3.107v5.073h3.108V256v2.916h-3.108v5.199h-3.107v2.916v2.916h-4.691v6.912h-1.569v3.297h-1.553h-1.57v-3.297h-1.537v-6.912 h-4.676v-5.834H24.4v-5.199h-3.092v-2.791v-0.19v-2.854h3.091v-5.073h3.139v-5.897h4.676v-6.91h1.537v-3.362h1.57h1.553v3.297 h1.569v6.975h4.692V242.113z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBy);
export default __webpack_public_path__ + "static/media/by.748f604bbd6269358bb5cb78a36649d3.svg";
export { ForwardRef as ReactComponent };